import React, { Component } from 'react'
import '../styles/VeryBadNight.css'
import PopIn from './PopIn'
import VBNCustom1 from '../images/Themes/VBN/vbn-custom-tshirt.png'
import VBNCustom2 from '../images/Themes/VBN/vbn-custom-2.png'
import VBNCustom3 from '../images/Themes/VBN/vbn-custom-3.jpg'
import { injectIntl, defineMessages } from "react-intl"

class PopInVBNCustom extends Component {

  render() {
    const {intl:{formatMessage}} = this.props
    return (
      <PopIn
        closePopIn={() => this.props.closePopIn()}
        title={formatMessage(messages.title)}
        klass="pop-in-inner--vbn-custom"
      >
        <p
          className="pop-in-baseline pop-in-vbn-baseline"
          style={{ display: 'block', position: 'relative', zIndex: 2 }}
        >{formatMessage(messages.baseline)}</p>
        <div className="pop-in-content" style={{ height: 'auto', overflow: 'visible' }}>
          <div
            className="pop-in-vbn-copy pop-in-vbn-copy--visible"
            style={{
              display: 'block',
              position: 'relative',
              zIndex: 2,
              color: '#fff',
              visibility: 'visible',
              opacity: 1,
              margin: '0 0 22px'
            }}
          >
            <h4 style={{ color: '#fff', margin: '0 0 12px' }}>{formatMessage(messages.contentTitle)}</h4>
            <p style={{ color: '#fff', margin: '0 0 3px' }}>- {formatMessage(messages.content1)}</p>
            <p style={{ color: '#fff', margin: '0 0 3px' }}>- {formatMessage(messages.content2)}</p>
            <p style={{ color: '#fff', margin: '0 0 14px' }}>- {formatMessage(messages.content3)}</p>
            <p style={{ color: '#fff', margin: 0 }}>{formatMessage(messages.content4)}</p>
          </div>
          <div
            className="pop-in-custom-container"
            style={{ position: 'relative', top: 'auto', left: 'auto', display: 'grid', zIndex: 1 }}
          >
          <p className="pop-in-custom-label">{formatMessage(messages.idealFor)}</p>
            <div className="pop-in-custom-card">
              <div
                className="pop-in-custom-icon"
                style={{backgroundImage: `url(${VBNCustom1})`}}
                ></div>
              <div className="pop-in-custom-text">{formatMessage(messages.idealForContent1)}</div>
            </div>
            <div className="pop-in-custom-card">
              <div
                className="pop-in-custom-icon"
                style={{backgroundImage: `url(${VBNCustom2})`}}
                ></div>
              <div className="pop-in-custom-text">{formatMessage(messages.idealForContent2)}</div>
            </div>
            <div className="pop-in-custom-card">
              <div
                className="pop-in-custom-icon"
                style={{backgroundImage: `url(${VBNCustom3})`}}
                ></div>
              <div className="pop-in-custom-text">{formatMessage(messages.idealForContent3)}</div>
            </div>
          </div>
        </div>
      </PopIn>
    )
  }
}

const messages = defineMessages({
  title: {
    id: 'popinVBNCustom.title',
    defaultMessage: 'Option de personnalisation'
  },
  baseline: {
    id: 'popinVBNCustom.baseline',
    defaultMessage: 'Pour 50€ en plus de votre session de jeu.'
  },
  contentTitle: {
    id: 'popinVBNCustom.contentTitle',
    defaultMessage: 'Voici ce que nous vous proposons :'
  },
  content1: {
    id: 'popinVBNCustom.content1',
    defaultMessage: "T-shirt personnalisé"
  },
  content2: {
    id: 'popinVBNCustom.content2',
    defaultMessage: "Personnalisation d'une énigme pour la personne sélectionnée"
  },
  content3: {
    id: 'popinVBNCustom.content3',
    defaultMessage: "Personnalisation de l'ambiance (playlist personnalisée...)"
  },
  content4: {
    id: 'popinVBNCustom.content4',
    defaultMessage: "Pour cela, nous vous enverrons un petit questionnaire dans lequel vous devrez nous donner plus d’informations sur la personne concernée : son nom ou surnom, des photos embarrassantes ou non, sa playlist, sa taille de t-shirt, etc."
  },
  idealFor: {
    id: 'popinVBNCustom.idealFor',
    defaultMessage: "Idéal pour :"
  },
  idealForContent1: {
    id: 'popinVBNCustom.idealForContent1',
    defaultMessage: "Anniversaires"
  },
  idealForContent2: {
    id: 'popinVBNCustom.idealForContent2',
    defaultMessage: "EVG / EFG"
  },
  idealForContent3: {
    id: 'popinVBNCustom.idealForContent3',
    defaultMessage: "Un peu de piment :)"
  },
})

export default injectIntl(PopInVBNCustom)



// WEBPACK FOOTER //
// ./src/components/PopInVBNCustom.js